@for(commentValues of commentResults; track commentValues.label){
    @for(comment of commentValues.comments; track comment; let first = $first; let last = $last){
        <div class="comment-result-item" [ngClass]="{'first': first, 'last': last}">
            @if(commentValues.position == -1){
                <div class="comment-result-item-value"
                     matTooltipPosition="left"
                     [matTooltip]="commentValues.label">
                    <i class="fa-light fa-xmark-to-slot fa-2x"></i>
                </div>
            }@else {
                @switch (itemType) {
                    @case ('closedQuestionResultItem') {
                        <div class="comment-result-item-value" 
                             matTooltipPosition="left"
                             [matTooltip]="commentValues.label">
                            <span class="border-0">
                                <i [ngClass]="'color' + commentValues.position" class="fa-solid fa-circle"></i>
                            </span>
                        </div>
                    }
                    @case ('agreeDisagreeQuestionResultItem') {
                        <div class="comment-result-item-value" 
                             matTooltipPosition="left"
                             [matTooltip]="commentValues.label">
                            <span [ngClass]="'color' + commentValues.position">{{commentValues.position}}/5</span>
                        </div>
                    }
                    @case ('scaleQuestionResultItem') {
                        <div class="comment-result-item-value" 
                             matTooltipPosition="left"
                             [matTooltip]="'1 = ' + commentResults[0].label + '\n 5 = ' + commentResults[commentResults.length-2].label">
                            <span [ngClass]="'color' + commentValues.position">{{commentValues.position}}/5</span>
                        </div>   
                    }
                    @case ('fiveStarsQuestionResultItem') {
                        <div class="comment-result-item-value" 
                             matTooltipPosition="left"
                             [matTooltip]="commentValues.label + '/5'">
                            <span class="border-0">{{commentValues.label}}<i class="fa-solid fa-star"></i></span>
                        </div>
                    }
                }
               
            }
            <span class="comment-result-item-comment" [innerHTML]="formatComment(comment)"></span>
        </div>
    }
}